export type Language = "ru" | "en";

export interface Settings {
  language: Language;
}

export const DEFAULT_SETTINGS: Settings = {
  language: "ru",
};
